import { ShopsView } from '@/views/Shops/Shops.view';
import { ServerDataProvider } from '@/contexts';
import { withPreRenderSettings } from '@/utils/hocs';
import NoSsr from '@/components/NoSsr/NoSsr';

function ShopsPage() {
  return (
    <ServerDataProvider>
      <NoSsr>
        <ShopsView />
      </NoSsr>
    </ServerDataProvider>
  );
}

ShopsPage.getInitialProps = withPreRenderSettings(() => ({}));

export default ShopsPage;
